<template>
  <div class="product-category-assignment-manager">
    <common-button
      :disabled="disabled"
      @click="newProductCategory"
      class="uk-margin"
      icon="plus"
      v-if="hasControls && hasProductCategories"
    >{{$t('actions.addProductCategory')}}</common-button>

    <product-category-assignment-form
      :product-categories="productCategories"
      :values="editedFormValues"
      @hidden="resetEditedProductCategory"
      @submit="submitProductCategory"
      ref="formModal"
    />

    <product-category-assignment-table
      :product-categories="productCategories"
      :show-actions="showTableActions"
      @edit="editProductCategory"
      @remove="removeProductCategory"
      v-if="hasProductCategories"
    />

    <div class="uk-placeholder uk-margin-remove-top uk-text-center" v-else>
      <div>
        <icon name="warning" />
        {{$t('hints.noProductCategories')}}
      </div>

      <common-button
        :disabled="disabled"
        @click="newProductCategory"
        class="uk-margin"
        icon="plus"
        v-if="hasControls"
      >{{$t('actions.addProductCategory')}}</common-button>
    </div>
  </div>
</template>

<script>
import { cloneDeep, sortBy } from 'lodash';
import CommonButton from '@/components/CommonButton';
import ProductCategoryAssignmentForm
  from '@/components/ProductCategoryAssignmentForm';
import ProductCategoryAssignmentTable
  from '@/components/ProductCategoryAssignmentTable';

function sortProductCategories(categories) {
  return sortBy(categories, [
    category => category.tenant && category.tenant.name.toLowerCase(),
    'name',
  ]);
}

export default {
  name: 'product-category-assignment-manager',
  components: {
    CommonButton,
    ProductCategoryAssignmentForm,
    ProductCategoryAssignmentTable,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
    hasControls: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value(value) {
      this.productCategories = sortProductCategories(cloneDeep(value || []));
    },
  },
  data() {
    return {
      productCategories: sortProductCategories(cloneDeep(this.value || [])),
      editedProductCategoryIndex: null,
    };
  },
  computed: {
    hasProductCategories() {
      return this.productCategories.length > 0;
    },
    editedFormValues() {
      if (!this.editedProductCategory) return null;
      return {
        category: this.editedProductCategory,
        tenant: this.editedProductCategory.tenant,
      };
    },
    editedProductCategory() {
      if (this.editedProductCategoryIndex === null) return null;
      return this.productCategories[this.editedProductCategoryIndex];
    },
    showTableActions() {
      return this.hasControls && !this.disabled;
    },
  },
  methods: {
    newProductCategory() {
      this.resetEditedProductCategory();
      this.$refs.formModal.show();
    },
    editProductCategory(index) {
      this.editedProductCategoryIndex = index;
      this.$refs.formModal.show();
    },
    submitProductCategory({ category }) {
      const { productCategories } = this;
      if (this.editedProductCategoryIndex === null) {
        productCategories.push(category);
      } else {
        productCategories[this.editedProductCategoryIndex] = category;
      }
      this.productCategories = sortProductCategories(productCategories);
      this.$refs.formModal.hide();
      this.onInput();
    },
    removeProductCategory(index) {
      this.productCategories.splice(index, 1);
      this.onInput();
    },
    resetEditedProductCategory() {
      this.editedProductCategoryIndex = null;
    },
    onInput() {
      this.$emit('input', this.productCategories);
      this.$emit('change', this.productCategories);
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          addProductCategory: 'Produktkategorie hinzufügen',
        },
        hints: {
          noProductCategories: 'Es wurden keine Produktkategorien zugeordnet.',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductCategoryAssignmentManager.vue?9154e6be